var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIAutocomplete',_vm._b({ref:"autocomplete",attrs:{"api-method":_vm.method,"item-text":"name","item-value":"id","label":_vm.label,"sort-by":['name'],"sort-orders":['asc']},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'UIAutocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }